var _ = require('underscore');
var $ = require('jQuery');

const cookieNotice = $('.cookie-notice');

$('#showCookieNotice').click(function (e) {
    e.preventDefault();
    $('.cookie-notice').removeClass('hidden').show();
    $('html, body').animate({ scrollTop: 0 }, 250);

});

$('.cookie-checkbox').each(function () {
    $(this).popover({
        trigger: 'manual',
        content: $(this).data('help-text'),
        placement: 'bottom',
        animation: false
    }).on('mouseenter', function () {
        $(this).popover('show');
        $('.popover').on('mouseleave', () => {
            $(this).popover('hide');
        });
    }).on('mouseleave', function() {
        setTimeout(() => {
            if (!$('.popover:hover').length) {
                $(this).popover('hide');
            }
        }, 300);
    });
});
$('body').on('keyup', function(e) {
    if (e.which === 27) {
        $('.popover').hide();
    }
});

if (cookieNotice.data('show-notice') == 1) {
    cookieNotice.delay(1000).removeClass('hidden').hide().slideDown('fast');
}
    const chooseCookies = cookieNotice.find('.choose-cookies');
    const necessaryCookies = cookieNotice.find('.necessary-cookies');
    const allowAllCookies = cookieNotice.find('.allow-cookies');
    const saveCookies = cookieNotice.find('.save-cookies');

    allowAllCookies.on('click', (event) => {
        event.preventDefault();

        let cookies = ['necessary', 'analytics', 'marketing', 'social-sharing'];
        cookies = cookies.filter(type => type);
        sendCookiesConsent(cookies);
    });

    necessaryCookies.on('click', (event) => {
        event.preventDefault();

        let cookies = ['necessary', null, null, null];
        cookies = cookies.filter(type => type);
        sendCookiesConsent(cookies);
    });

    chooseCookies.on('click', (event) => {
        event.preventDefault();
        const cookieSelectionHidden = $('.cookie-selection').hasClass('hidden');

        if (cookieSelectionHidden) {
            $('.cookie-selection').removeClass('hidden').slideDown('fast');
        } else {
            $('.cookie-selection').addClass('hidden');
        }
    });

    saveCookies.on('click', (event) => {
        event.preventDefault();

        let cookies = [
            cookieNotice.find('input[name="necessary"]').is(':checked') ? 'necessary' : null,
            cookieNotice.find('input[name="analytics"]').is(':checked') ? 'analytics' : null,
            cookieNotice.find('input[name="marketing"]').is(':checked') ? 'marketing' : null,
            cookieNotice.find('input[name="social-sharing"]').is(':checked') ? 'social-sharing' : null,
        ];

        cookies = cookies.filter(type => type);
        sendCookiesConsent(cookies);
    });

    function sendCookiesConsent(cookies)
    {
        $.ajax({
            type: 'POST',
            url: '/cookies/accept',
            data: {
                cookies: cookies
            }
        }).success((response) => {
            cookieNotice.slideUp('fast').queue(() => {
                // Reloading the page enables services that depend on cookie consent
                // (specifically AddThis social sharing buttons on the home page)
                window.location.reload();
            });
        });
    };


